import React, { useState } from 'react';
import { ComparisonService } from '../../../../types/competitors';
import {
    Collapse,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
} from '@mui/material';
import useTranslate from '../../../../../../customHooks/useTranslate';
import Tag from '../../../../../../muiComponents/Tag';
import IconButton from '../../../../../../muiComponents/IconButton';
import { commonIcons } from '../../../../../../utils/commonVariables/commonIcons';
import {
    competitorServiceStatusConfig,
    getCompetitorViewerReadStatusConfig,
} from '../../../../utils/AIScraperPanelsUtils';

export interface CompetitorCategorySectionProps {
    categoryName: string;
    services: ComparisonService[];
    hotelName: string;
    competitorName: string;
}

const CompetitorCategorySection = ({
    categoryName,
    services,
    hotelName,
    competitorName,
}: CompetitorCategorySectionProps) => {
    const translate = useTranslate();
    const [isExpanded, setIsExpanded] = useState(true);
    const columns = [
        {
            id: 'serviceCategory',
            label: translate('service'),
        },
        {
            id: 'hotel',
            label: hotelName,
            className: '--hotel',
        },
        {
            id: 'competitor',
            label: competitorName,
            className: '--competitor',
        },
        {
            id: 'read',
            label: translate('read'),
        },
    ];
    return (
        <div key={categoryName} className='competitor-viewer__service-category'>
            <div className='competitor-viewer__service-category__header'>
                <div className='flex flex-align-baseline gap-30 '>
                    <h3 className='competitor-viewer__service-category__title'>
                        {categoryName}
                    </h3>
                    <p className='competitor-viewer__service-category__service-count'>{`${
                        services.length
                    } ${translate(
                        services.length === 1 ? 'service' : 'services'
                    )}`}</p>
                </div>
                <IconButton
                    type='button'
                    aria-label={categoryName}
                    aria-expanded={isExpanded}
                    onClick={() => setIsExpanded(previous => !previous)}
                    iconName={
                        isExpanded
                            ? commonIcons.ARROW_UP
                            : commonIcons.ARROW_DOWN
                    }
                />
            </div>
            <Collapse in={isExpanded} timeout='auto'>
                <div className='competitor-viewer__service-category__table-container'>
                    <Table className='competitor-viewer__service-category__table'>
                        <TableHead>
                            <TableRow>
                                {columns.map(column => (
                                    <TableCell key={column.id}>
                                        <div
                                            className={`competitor-viewer__service-category__table-cell ${
                                                column.className || ''
                                            }`}
                                        >
                                            {column.label}
                                        </div>
                                    </TableCell>
                                ))}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {services.map(service => {
                                const readStatus =
                                    getCompetitorViewerReadStatusConfig(
                                        service.ownHotel,
                                        service.competitor
                                    );
                                const competitorServiceStatus =
                                    service.competitor
                                        ? competitorServiceStatusConfig.offered
                                        : competitorServiceStatusConfig.not_offered;
                                const ownServiceStatus = service.ownHotel
                                    ? competitorServiceStatusConfig.offered
                                    : competitorServiceStatusConfig.not_offered;

                                return (
                                    <TableRow key={service.code}>
                                        <TableCell>{service.name}</TableCell>
                                        <TableCell>
                                            <Tag
                                                variant='outlined'
                                                uppercase
                                                text={ownServiceStatus.text}
                                                color={ownServiceStatus.color}
                                            />
                                        </TableCell>
                                        <TableCell>
                                            <Tag
                                                variant='outlined'
                                                uppercase
                                                text={
                                                    competitorServiceStatus.text
                                                }
                                                color={
                                                    competitorServiceStatus.color
                                                }
                                            />
                                        </TableCell>
                                        <TableCell>
                                            <Tag
                                                variant='outlined'
                                                uppercase
                                                text={
                                                    competitorServiceStatusConfig[
                                                        readStatus
                                                    ].text
                                                }
                                                color={
                                                    competitorServiceStatusConfig[
                                                        readStatus
                                                    ].color
                                                }
                                            />
                                        </TableCell>
                                    </TableRow>
                                );
                            })}
                        </TableBody>
                    </Table>
                </div>
            </Collapse>
        </div>
    );
};

export default CompetitorCategorySection;
